import React, { useState, useEffect } from 'react';
import { Collection } from '../../types/collections';

interface CollectionNotificationProps {
  collection: Collection;
  onClose: () => void;
  duration?: number;
}

const CollectionNotification: React.FC<CollectionNotificationProps> = ({
  collection,
  onClose,
  duration = 5000,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for fade-out animation before calling onClose
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [duration, onClose]);

  const getNotificationMessage = () => {
    switch (collection.status) {
      case 'Sent':
        return `Collection request (${collection.reference}) sent to ${collection.partnerName}`;
      case 'Paid':
        return `${collection.partnerName} has paid ${collection.currency} ${collection.amount.toLocaleString()}`;
      case 'Overdue':
        return `Collection ${collection.reference} is overdue. Follow up with ${collection.partnerName}`;
      default:
        return `Collection status updated for ${collection.partnerName}`;
    }
  };

  const getNotificationColor = () => {
    switch (collection.status) {
      case 'Sent':
        return '#1976D2';
      case 'Paid':
        return '#388E3C';
      case 'Overdue':
        return '#D32F2F';
      default:
        return '#F57C00';
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: 'white',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        borderRadius: '8px',
        padding: '15px 20px',
        maxWidth: '400px',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        borderLeft: `4px solid ${getNotificationColor()}`,
        zIndex: 1000,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 style={{ margin: '0 0 5px 0' }}>Collection Update</h4>
        <button
          onClick={() => {
            setIsVisible(false);
            setTimeout(onClose, 300);
          }}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '18px',
          }}
        >
          &times;
        </button>
      </div>
      <p style={{ margin: 0 }}>{getNotificationMessage()}</p>
    </div>
  );
};

export default CollectionNotification; 